angular.module('picmonic-common').factory('ReferralDataService', [
  'ReferralResource',
  function (ReferralResource) {
    return {
      promise: null,
      referral: {},
      init: function (referrerCode) {
        var self = this;
        if (self.promise) {
          self.promise.then(function () {
            if (
              !self.referral.referral_code ||
              (self.referral.referral_code &&
                referrerCode &&
                self.referral.referral_code !== referrerCode &&
                self.referral.referral_code !== referrerCode.slice(0, -5))
            ) {
              self.get(referrerCode);
            }
          });
        } else {
          self.get(referrerCode);
        }
      },
      get: function (referrerCode) {
        var self = this;
        var data = referrerCode ? { referral_code: referrerCode } : {};
        self.referral = ReferralResource.get(data);
        self.promise = self.referral.$promise;
      },
    };
  },
]);
